// FETCH
export const FETCH_HANDOVER = "app/HANDOVER/FETCH_HANDOVER";
export const FETCH_HANDOVER_SUCCESS = "app/HANDOVER/FETCH_HANDOVER_SUCCESS";
export const FETCH_HANDOVER_FAILURE = "app/HANDOVER/FETCH_HANDOVER_FAILURE";
